'use client'

import { type Table } from '@tanstack/react-table'
import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { ShippingRateItem } from '@/lib/api/shippingRates'

interface ShippingRatesTableActionsProps {
	table: Table<ShippingRateItem>
	onRefresh: () => void
	isLoading: boolean
	storeId: string
}

/**
 * ShippingRatesTableActions component for table toolbar actions
 */
export function ShippingRatesTableActions({ table, onRefresh, isLoading, storeId }: ShippingRatesTableActionsProps) {
	const { t } = useTranslation('shippings')

	return (
		<div className="flex items-center gap-2">
			<Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
				<RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
				{t('refresh')}
			</Button>
		</div>
	)
}

